
import EventBus from './../../eventBus'
import {Component,Mixins} from 'vue-property-decorator'
import UserProVisioning from "@/mixins/userProvisioning"

interface OperationUnit {
  name: string
  code: any
  departmentId: string
  mail: any
  numberOfMembers: string
  id: string
  link: any
}

interface Department {
  name: string
  code: string
  operationUnits: OperationUnit[]
  id: string
  link: string
}

@Component
export default class DepartmentsOverview extends Mixins(UserProVisioning){
    // DATA
   search: string = ''
   error: string = ''
   activeScreen: string = 'loading'
   loadingMessage: string = 'Loading Departments'
   loadingTitle: string = 'Loading...'
   selectedDept: any = {
       name: '',
       people: ''
   }
   deletePromptProperty: boolean = false
   successMessage: string = ''
   additionalSuccessMessage = ''
   loader: boolean = true
   selectedRows: {name: string; id: string}[] = []
   selectAll: boolean = false


    // METHODS 

    fetchSequences() {
        return this.$store.dispatch('sequencesModule/fetchSequences')
    }

    deleteDeptPrompt (selectedDept: any) {
        this.selectedDept.name=selectedDept.name
        this.selectedDept.id = selectedDept.id
        this.selectedDept.people=selectedDept.people

        this.deletePromptProperty = true
    }

    getDepartmentsToDelete () {
        const departmentNames = this.selectedRows.map(row => row.name);

        let formattedNames = '';

        if (departmentNames.length <= 3) {
            const lastTwoNames = this.selectedRows.map(row => row.name).splice(-2);
            return `${departmentNames.length === 3 ? `${departmentNames[0]},` : ''} ${lastTwoNames.join(' and ')}`
        }
        else {
            const firstTwoNames = departmentNames.slice(0, 2);
            const remainingCount = departmentNames.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} department${remainingCount > 1 ? 's' : ''}`;
        }
    }

    doDelete() {
        const isMultipleDelete = this.selectedRows.length;
        this.activeScreen = 'loading'
        this.loadingMessage = `Please wait while we delete ${isMultipleDelete ? 'these' : 'this'} department`
        this.loadingTitle = 'Deleting...'
        EventBus.$emit('activeScreen', this.activeScreen)

        const payload = isMultipleDelete ? this.selectedRows.map(row => row.id) : [this.selectedDept.id]
        this.deleteDepartment(payload).then((response: any) => {
            this.activeScreen = 'successNoBack'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.additionalSuccessMessage = `${isMultipleDelete ? 'These Departments': 'This Department'} will no longer be available when creating users`
            this.successMessage = `${isMultipleDelete ? this.getDepartmentsToDelete() : this.selectedDept.name} Deleted Successfully`
            this.deletePromptProperty = false
            this.selectedRows = [];
        }, (error: any) => {
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.response.data.message
            this.deletePromptProperty = false
        })
    }

    gotoEdit(dept_id: number){
        this.$router.push({path:'/manage-department/', query:{id:dept_id.toString()} })
    }

    searchValue(e: any) {
        this.search = e
    }

    toggleSelectAll() {
        if (!this.selectAll) {
            this.selectedRows = this.fillteredDepartments(this.search).map((dept: Department) => ({id: dept.id, name: dept.name}))
        } else {
            this.selectedRows = []
        }
    }

    // VUEX METHODS

    getDepartments () {
        return this.$store.dispatch('departmentModule/getDepartments')
    }

    deleteDepartment (payload: string[]) {
        return this.$store.dispatch('departmentModule/deleteDepartment', payload)
    }


    // COMPUTED PROPERTIES
    get fillteredDepartments() {
        return this.$store.getters['departmentModule/fillteredDepartments']
    }

    get sortedDepartments() {
        return this.fillteredDepartments(this.search).sort((a: any, b: any) => {
            const itemA = (a.name || '').toString().toLowerCase().trim();
            const itemB = (b.name || '').toString().toLowerCase().trim();
            return itemA.localeCompare(itemB, undefined, {
                sensitivity: 'base',
                numeric: true
            });
        });
    }
    get getAllDepartments() {
        return this.$store.getters['departmentModule/getAllDepartments']
    }
    get fields() {
        let fields: { key: string, label?: string, sortable?: boolean, thStyle?: {[key: string]: string} }[] =
            [
                { key: 'selectRow', label: 'Select', sortable: false, thStyle: { width: "60px" }, },
                { key: 'serial', label: 'S/N', sortable: false }, 
                { key: 'name', sortable: true, }, 
                { key: 'code', sortable: false, }
            ]
        if (this.canWriteDepartment) {
            fields.push({ key: 'button', label: "Actions" })
        }
        if (!this.canWriteSequence) {
            fields.shift()
        }
        return fields
    }
    get filteredSequences() {
        return this.$store.getters['sequencesModule/filteredRootSequences']
    }

    disableDelete(departmentId:any){
        let q = this.filteredSequences('').findIndex((seq:any) => seq.departments.some((department:any)=> department.id == departmentId))
        if (q >= 0) {
            return true
        }else {
            return false
        }
    }

    disableBtnDelete() {
        const departmentIds = this.selectedRows.map(row => row.id);

        return this.filteredSequences('').some((seq: any) => 
            seq.departments.some((department: any) => 
                departmentIds.includes(department.id)
            )
        );
    }



    // CREATED
    created() {
        
        if(this.filteredSequences('').length === 0) {
            this.fetchSequences();
        }

        if(this.fillteredDepartments('').length===0){
            this.getDepartments().then(response=>{
                this.activeScreen = 'main';
                EventBus.$emit('activeScreen', this.activeScreen)
                this.loader = false
            })
        }else{
            this.activeScreen = 'main';
            EventBus.$emit('activeScreen', this.activeScreen)
            this.loader = false
        }   
    }
}
